import { localize } from '../i18n';
import React, { useEffect, useState } from 'react';
import WebviewMessenger from '../utils/WebviewMessenger';
import AppToast from './AppToast';

export default function ExternalUrlErrorToast() {
    const [open, setOpen] = useState(false);
    useEffect(() => WebviewMessenger.onMessage(message => {
        if (message.type === 'EXTERNAL_URL_ERROR') setOpen(true);
    }), []);
    return <AppToast open={open} severity="error" message={localize("링크를 열지 못했어요. 잠시 후 다시 시도해주세요.")} onClose={() => setOpen(false)} />;
}
